/* eslint-disable react/no-array-index-key */
import React from "react";
import { ReactComponent as Droplet } from "assets/svg/droplet.svg";

const attributeIds = [
  "name",
  "sulfated_ash_percentage",
  "tbn",
  "sae_grade",
  "performance_odi",
  "wear_protection",
  "oxidation_nitration",
  "engine_cleanliness",
];

function createDroplets(value) {
  return Array.from(new Array(value)).map((_val, index) => (
    <Droplet key={index} />
  ));
}

function countDecimals(value) { 
  if ((value % 1) !== 0) 
      return value.toString().split(".")[1].length;  
  return 0;
};

function renderSulphurAshPercentage(value) {
  const decimals = countDecimals(value);

  return `${decimals > 1 ? value.toFixed(2): value.toFixed(1) }%`
}

const colRendererMap = {
  engine_cleanliness: createDroplets,
  oxidation_nitration: createDroplets,
  performance_odi: createDroplets,
  sulfated_ash_percentage: renderSulphurAshPercentage,
  wear_protection: createDroplets,
};

function colRenderer(colName, value) {
  return colRendererMap[colName] ? colRendererMap[colName](value) : value;
}

export { attributeIds, colRenderer };
